import styled from "@emotion/styled";
import { Card, CardContent, css } from "@mui/material";

export const GridData = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  margin-bottom: auto;
  margin-top: 15px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
  gap: 10px;
  a {
    text-decoration: none;
    color: inherit;
  }
  > div {
    border-radius: 30px;
    text-align: center;
  }

  .link {
    max-width: fit-content;
    @media (max-width: 425px) {
      margin: auto;
    }
  }
`;

export const StyledCard = styled(Card)`
  padding: 40px 0px;
  height: 300px;
  min-width: 300px;
  max-width: 50%;
  border-radius: 25px;
  color: #114c97;
  transition: 0.2s;
  box-shadow: 0px 3px 6px #00000029;
  filter: grayscale(100%);
  :hover {
    transform: scale(1.025);
  }
  ${(props) =>
    props.estado !== "deshabilitado" &&
    css`
      filter: grayscale(0%);
      :hover {
        transition: 0.2s;
        background-color: #114c97;
        color: floralwhite;
        cursor: pointer;
      }
    `}

  ${(props) => css`
    background-image: url(${props.image});
    background-position: center;
    background-size: cover;
  `}
`;
export const StyledCardContent = styled(CardContent)`
  display: flex;
  height: 80%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
